import React, { useState, useEffect, useRef } from "react";
import CssTransition from "../../../component/layout/css-transition";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import "./Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getSkuInventoryData,
  getProdcutInventoryData,
} from "../../../redux/actions/inventory";
import moment from "moment";
import Loader from "react-spinner-loader";
import "./InventoryCalendar.css";
import {
  GET_PRODUCT_INVENTORY_DATA,
  GET_SKU_INVENTORY_DATA,
} from "../../../redux/constants";

function Calendar({
  openCalendarModal,
  setOpenCalendarModal,
  skuMasterId,
  setSkuMasterId,
  formik,
  fieldValueToSet,
  setFieldValueToSet,
  productMasterId,
  setProductMasterId,
}) {
  const calendarRef = useRef();

  // State
  const [loader, setLoader] = useState(false);
  const [events, setEvents] = useState([]);

  // Redux
  const dispatch = useDispatch();
  const { skuInventoryData, productInventoryData } = useSelector(
    (state) => state.inventory
  );

  // Function to call API for Day Wise Purchase Order
  const getOrderDetailsDayWise = () => {
    setLoader(true);
    const request = {
      tableView: {
        value: "day",
      },
      payload: {
        skus: [
          {
            sku_master_id: skuMasterId,
            sequence: 1,
          },
        ],
      },
      onSuccess: () => {
        setLoader(false);
      },
      onError: (err) => {
        setLoader(false);
      },
    };

    dispatch(getSkuInventoryData(request));
  };

  // Function to call API for Day Wise Production Order
  const getDayWiseOrderDetailsForProduct = () => {
    setLoader(true);
    const request = {
      tableView: {
        value: "day",
      },
      payload: {
        products: [
          {
            product_master_id: productMasterId,
            sequence: 1,
          },
        ],
      },
      onSuccess: () => {
        setLoader(false);
      },
      onError: (err) => {
        setLoader(false);
      },
    };

    dispatch(getProdcutInventoryData(request));
  };

  // Function to create events
  const createEvents = (eventData) => {
    setEvents(
      eventData.map((element) => {
        const obj = {
          title: element.closingStock,
          start: `${element.yearNumber}-${moment(
            `${element.yearNumber}-${element.monthNumber}-${element.dayNumber}`
          ).format("MM")}-${moment(
            `${element.yearNumber}-${element.monthNumber}-${element.dayNumber}`
          ).format("DD")}`,
        };
        if (skuInventoryData.length > 0) {
          obj.backgroundColor =
            element.closingStock < skuInventoryData?.[0]?.min_qty
              ? element.closingStock < 0
                ? "#D31313"
                : "#F7921E"
              : "#2F80ED";
          obj.borderColor =
            element.closingStock < skuInventoryData?.[0]?.min_qty
              ? element.closingStock < 0
                ? "#D31313"
                : "#F7921E"
              : "#2F80ED";
        } else {
          obj.backgroundColor =
            element.closingStock < productInventoryData?.[0]?.min_qty
              ? element.closingStock < 0
                ? "#D31313"
                : "#F7921E"
              : "#2F80ED";
          obj.borderColor =
            element.closingStock < productInventoryData?.[0]?.min_qty
              ? element.closingStock < 0
                ? "#D31313"
                : "#F7921E"
              : "#2F80ED";
        }
        return obj;
      })
    );
  };

  useEffect(() => {
    if (skuMasterId) {
      getOrderDetailsDayWise();
    } else if (productMasterId) {
      getDayWiseOrderDetailsForProduct();
    }
  }, [skuMasterId, productMasterId]);

  useEffect(() => {
    if (skuInventoryData?.[0]?.dayWise) {
      createEvents(skuInventoryData?.[0]?.dayWise);
    } else if(productInventoryData?.[0]?.dayWise) {
      createEvents(productInventoryData?.[0]?.dayWise);
    }
  }, [skuInventoryData, productInventoryData]);

  // Function to show customized event
  const renderEventContent = (eventInfo) => {
    return (
      <div className={`overflow-hidden cursor-pointer relative z-10`}>
        <div className="text-left text-xs font-medium text-white flex flex-row items-center w-auto">
          <span className="truncate text-white">{eventInfo.event.title}</span>
        </div>
      </div>
    );
  };

  // Function to get selected date range
  const getSelectedDate = (selectionInfo) => {
    const { startStr, endStr } = selectionInfo;
    const filteredEvent = events.find((item) => item.start === endStr);

    // console.log({filteredEvent})
    // console.log("skuInventoryData?.[0]?.min_qty ==>", skuInventoryData?.[0]?.min_qty);

    if (skuMasterId) {
      if (filteredEvent.title >= skuInventoryData?.[0]?.min_qty) {
        formik.setFieldValue(fieldValueToSet, 0);
      } else {
        formik.setFieldValue(
          fieldValueToSet,
          skuInventoryData?.[0]?.min_qty - filteredEvent.title
        );
      }
      setSkuMasterId();
    } else {
      if (filteredEvent.title >= productInventoryData?.[0]?.min_qty) {
        formik.setFieldValue(fieldValueToSet, 0);
      } else {
        formik.setFieldValue(
          fieldValueToSet,
          productInventoryData?.[0]?.min_qty - filteredEvent.title
        );
      }
      setProductMasterId()
    }

    setFieldValueToSet();
    dispatch({ type: GET_PRODUCT_INVENTORY_DATA, payload: [] });
    dispatch({ type: GET_SKU_INVENTORY_DATA, payload: [] });
    setOpenCalendarModal(false);
  };

  return (
    <div
      onClick={(e) => {
        if (e.target.id === "modal1" || e.target.id === "modal2") {
          dispatch({ type: GET_PRODUCT_INVENTORY_DATA, payload: [] });
          dispatch({ type: GET_SKU_INVENTORY_DATA, payload: [] });
          setOpenCalendarModal(false);
        }
      }}
    >
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openCalendarModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
        id="modal1"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openCalendarModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
        id="modal2"
      >
        <div className="bg-white w-full overflow-auto max-w-4xl max-h-full rounded-[20px] shadow-lg flex flex-col p-4 space-y-4">
          <div className="h-[550px] w-full">
            {loader ? (
              <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full calendar-spinner">
                <Loader show={loader} />
              </div>
            ) : (
              <div className="h-[90%]">
                <FullCalendar
                  ref={calendarRef}
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  selectable={true}
                  select={getSelectedDate}
                  fixedWeekCount={false}
                  eventClassNames="inventory-calendar"
                  events={events}
                  eventContent={renderEventContent}
                  dayMaxEventRows={true}
                  handleWindowResize={true}
                  height="100%"
                />
              </div>
            )}
          </div>
        </div>
      </CssTransition>
    </div>
  );
}

export default Calendar;
